export const Product_list_req = 'Product_list_req';
export const Product_list_success = 'Product_list_success';
export const Product_list_fail = 'Product_list_fail';

export const Product_details_req = 'Product_details_req';
export const Product_details_success = 'Product_details_success';
export const Product_details_fail = 'Product_details_fail';